import * as React from 'react';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import { staticTheme } from '@/utils/theme';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { colors, Icon, Text, grid } from '@zopauk/react-components';
import { useServerExperiment } from '@zopauk/nextjs-amplitude-experiment/client';

interface InformationBannerProps {
  cookieName: string;
}

const Banner = styled.div`
  position: relative;
  background-color: ${colors.warning};
  padding: 8px 40px 8px 20px;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px 10px;
  background: transparent;
  border: 0;
  cursor: pointer;
  @media screen and (min-width: ${grid.breakpoints.m}) {
    right: 10px;
  }
`;

const CloseIcon = styled(Icon)`
  height: 20px;
  width: 20px;
`;

export function InformationBanner({ cookieName }: InformationBannerProps) {
  const [visible, setVisible] = React.useState(false);
  const { data } = useServerExperiment('quopa-maintenance-warning-banner', {
    endpoint: `${staticTheme().basePath}/api/experiment`,
  });

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setVisible(!Cookies.get(cookieName));
  }, [cookieName]);

  if (!data || data?.['quopa-maintenance-warning-banner']?.key !== 'on') {
    return null;
  }

  const bannerCopy = data?.['quopa-maintenance-warning-banner']?.payload;
  if (typeof bannerCopy !== 'string') {
    return null;
  }

  return visible ? (
    <Banner>
      <Text color={colors.greyDarkest} as="p">
        {bannerCopy}
      </Text>
      <CloseButton
        onClick={() => {
          Cookies.set(cookieName, 'true', { expires: 1 });
          setVisible(false);
        }}
        aria-label="Close the banner"
      >
        <CloseIcon color={colors.greyDarkest} variant={faTimes} />
      </CloseButton>
    </Banner>
  ) : null;
}

export default InformationBanner;
